// extracted by mini-css-extract-plugin
export var closed = "_bo-1";
export var resizer = "_bo-0";